import z from "zod/v4";
import { uriComponent } from "./uriComponent";

export const s3ObjectKey = z
  .codec(z.string(), z.string(), {
    decode: (encoded) => encoded.replace(/\+/g, " "),
    encode: (decoded) => decoded.replace(/ /g, "+"),
  })
  .pipe(uriComponent);
